/**
 * kg CO₂e avoided vs virgin manufacturing — conservative defaults.
 * Tune with Assettech; used only by sustainabilityReportMetrics (no LLM).
 */
export const DEFAULT_CO2_KG_REUSED = 280;
export const DEFAULT_CO2_KG_RECYCLED = 45;

/** Normalized device_type key → kg CO₂e per device when reused/recycled. */
export const CO2_KG_REUSED_BY_DEVICE_TYPE: Record<string, number> = {
  laptop: 320,
  desktop: 350,
  server: 500,
  phone: 180,
  tablet: 200,
  monitor: 120,
  printer: 90,
  networking: 100,
  other: 280,
};

export const CO2_KG_RECYCLED_BY_DEVICE_TYPE: Record<string, number> = {
  laptop: 55,
  desktop: 60,
  server: 85,
  phone: 35,
  tablet: 40,
  monitor: 25,
  printer: 20,
  networking: 22,
  other: 45,
};

export const SANITIZED_DD_STATUSES = new Set([
  'data wiped',
  'data destroyed',
  'wiped',
]);
